<template>
    <section :id="id">
        <SectionTitle>
            {{ $t(fieldConfig.label) }}
        </SectionTitle>
        <div>
            <div class="search-preference__alg-label">
                <label class="search-preferences--radio">
                    <input
                        v-model="fieldValue"
                        :value="MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast"
                        type="radio"
                        @change="syncChange"
                    >
                    <span class="search-preferences--value">
                        {{ $t("Search.labels.algorithmTypes.Blast") }}
                    </span>
                </label>
                <label class="search-preferences--radio">
                    <input
                        v-model="fieldValue"
                        :value="MODIFICATION_SEARCH_ALGORITHM_TYPES.NW"
                        type="radio"
                        @change="syncChange"
                    >
                    <span class="search-preferences--value">
                        {{ $t("Search.labels.algorithmTypes.Nw") }}
                    </span>
                </label>
                <ElPopover
                    :visible-arrow="false"
                    :width="458"
                    placement="right"
                    trigger="hover"
                    popper-class="bio-search-setting__popover"
                >
                    <div class="preferences-propver__content">
                        <p
                            v-html="$t('Search.propver.Preferences.algorithmDescription.1')"
                        />
                        <img :src="store.safeImagesUrl('globalAlignmentExplanation.1')">
                        <p
                            v-html="$t('Search.propver.Preferences.algorithmDescription.2')"
                        />
                        <img :src="store.safeImagesUrl('globalAlignmentExplanation.2')">
                        <p
                            v-html="$t('Search.propver.Preferences.algorithmDescription.3')"
                        />
                    </div>
                    <PtIcon
                        slot="reference"
                        icon="SolidInfo"
                        style="margin-left: 12px"
                    />
                </ElPopover>
            </div>
        </div>
    </section>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import Popover from 'element-ui/lib/popover';
import { MODIFICATION_SEARCH_ALGORITHM_TYPES } from '../constants';
import SectionTitle from '../components/SectionTitle.vue';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        PtIcon,
        SectionTitle,
        ElPopover: Popover,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'algorithm_type',
        },
    },
    data() {
        return {
            MODIFICATION_SEARCH_ALGORITHM_TYPES,
        };
    },
};
</script>
